var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFillError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 3.33325C10.7997 3.33325 3.33301 10.7999 3.33301 19.9999C3.33301 29.1999 10.7997 36.6666 19.9997 36.6666C29.1997 36.6666 36.6663 29.1999 36.6663 19.9999C36.6663 10.7999 29.1997 3.33325 19.9997 3.33325ZM21.6663 28.3333H18.333V24.9999H21.6663V28.3333ZM21.6663 21.6666H18.333V11.6666H21.6663V21.6666Z",
    fill: "#C91432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillError);
export default __webpack_public_path__ + "static/media/icon_fill_error.2b26b16640b29aaac9d66c73ba525bee.svg";
export { ForwardRef as ReactComponent };